import React from 'react';

const rows = [
  { label: 'Languages', value: 'Python (Pandas, NumPy, SciPy, scikit-learn, PyTorch, TensorFlow), SQL, R' },
  { label: 'Data & storage', value: 'PostgreSQL (incl. pgvector), MSSQL, ETL design, feature stores' },
  { label: 'Cloud & MLOps', value: 'Azure (ML, Data Factory, Data Lake, Databricks), AWS, Docker, CI/CD' },
  { label: 'BI & reporting', value: 'Power BI, advanced Excel, Power Query, dashboard design' },
  { label: 'AI / ML', value: 'RAG, hybrid search, computer vision (YOLOv7), model evaluation & monitoring' },
  { label: 'Spatial', value: 'ArcGIS, QGIS, offline field capture with cloud sync' },
];

const foundations = {
  label: 'Foundations',
  value: 'Probability & statistics, stochastic processes, optimisation, network science',
};

const certs = [
  { text: 'Microsoft Certified: Azure Data Scientist Associate', dot: '#38e0ff' },
  { text: 'Microsoft Certified: Azure AI Engineer Associate', dot: '#38e0ff' },
  { text: 'Microsoft Certified: Azure AI Fundamentals', dot: '#38e0ff' },
  { text: 'AWS Certified Cloud Practitioner', dot: '#ff8fce' },
];

const Capabilities = () => (
  <section
    id="stack"
    style={{
      background: 'linear-gradient(180deg, rgba(56,224,255,0.04) 0%, rgba(255,62,165,0.035) 100%)',
      borderTop: '1px solid rgba(255,255,255,0.06)',
      borderBottom: '1px solid rgba(255,255,255,0.06)',
    }}
  >
    <div
      className="zk-section-pad zk-section-gutter"
      style={{ maxWidth: '1180px', margin: '0 auto', padding: '110px 56px' }}
    >
      <div style={{ marginBottom: '46px' }}>
        <span style={{ fontFamily: 'var(--zk-mono)', fontSize: '12px', letterSpacing: '0.28em', color: '#ff3ea5' }}>
          {'// CAPABILITIES_STACK'}
        </span>
        <h2
          style={{
            margin: '18px 0 0',
            fontSize: 'clamp(34px, 4vw, 52px)',
            fontWeight: 600,
            letterSpacing: '-0.02em',
            lineHeight: 1.04,
          }}
        >
          Tools and methods.
        </h2>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 0, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
        {rows.map((r) => (
          <div
            key={r.label}
            className="zk-capability-row"
            style={{
              display: 'grid',
              gridTemplateColumns: '200px 1fr',
              gap: '24px',
              padding: '20px 0',
              borderBottom: '1px solid rgba(255,255,255,0.08)',
              alignItems: 'start',
            }}
          >
            <span style={{ fontFamily: 'var(--zk-mono)', fontSize: '13px', letterSpacing: '0.06em', color: '#38e0ff' }}>
              {r.label}
            </span>
            <span style={{ fontSize: '15px', lineHeight: 1.6, color: 'rgba(232,238,240,0.78)' }}>{r.value}</span>
          </div>
        ))}
        <div
          className="zk-capability-row"
          style={{
            display: 'grid',
            gridTemplateColumns: '200px 1fr',
            gap: '24px',
            padding: '24px 22px',
            margin: '0 -22px',
            background: 'rgba(255,62,165,0.07)',
            border: '1px solid rgba(255,62,165,0.28)',
            borderRadius: '3px',
            alignItems: 'start',
          }}
        >
          <span style={{ fontFamily: 'var(--zk-mono)', fontSize: '13px', letterSpacing: '0.06em', color: '#ff3ea5', fontWeight: 500 }}>
            {foundations.label}
          </span>
          <span style={{ fontSize: '15px', lineHeight: 1.6, color: '#fff' }}>{foundations.value}</span>
        </div>
      </div>

      <div style={{ marginTop: '42px', paddingTop: '32px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
        <span
          style={{
            fontFamily: 'var(--zk-mono)',
            fontSize: '11px',
            letterSpacing: '0.18em',
            color: 'rgba(232,238,240,0.5)',
            textTransform: 'uppercase',
          }}
        >
          Certifications
        </span>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginTop: '18px' }}>
          {certs.map((c) => (
            <span
              key={c.text}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '9px',
                padding: '11px 16px',
                background: 'rgba(255,255,255,0.02)',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '2px',
                fontSize: '13px',
                color: 'rgba(232,238,240,0.84)',
              }}
            >
              <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: c.dot }} />
              {c.text}
            </span>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Capabilities;
